import { CacheLookupPolicy, type Configuration } from "@azure/msal-browser";

// localStorage (e não sessionStorage): o login vale em todas as abas. O MSAL v5
// criptografa esse cache com uma chave num cookie de sessão (msal.cache.encryption):
// fechar o navegador invalida tudo.
// redirectUri /login: a ponte com o login do portal (components/portal/login-bridge.tsx).
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_AZURE_AD_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.NEXT_PUBLIC_AZURE_AD_TENANT_ID!}`,
    redirectUri: "/login",
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

// Token do cache ou renovado pelo refresh token, nunca pelo iframe oculto do MSAL:
// o iframe exigiria um redirectUri só para ele (/blank.html) cadastrado no App
// Registration. Se o refresh token também venceu, quem chama segue pelo login de
// página inteira (acquireTokenRedirect ou a ponte do /login).
export const NO_IFRAME = { cacheLookupPolicy: CacheLookupPolicy.AccessTokenAndRefreshToken };

export const loginRequest = {
  scopes: [`api://${process.env.NEXT_PUBLIC_AZURE_AD_CLIENT_ID}/access_as_user`],
};
